import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http'; // still needed for some components
import { RouterModule } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';

import { Store, StoreModule } from '@ngrx/store';
import { ConfigModule } from '@ngx-config/core';
import { MetaModule } from '@ngx-meta/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NotifierModule } from 'angular-notifier';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { GestureConfig } from '@angular/material';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { ConfigSettings } from './shared/config/config';
import { AppEffects } from 'app/shared/state-management/effects/app';
import { RouterEffects } from 'app/shared/state-management/effects/router';
import { LayoutComponentModules } from './layout/components';
import { BroadcastChannelModule } from './shared/services/broadcast-channel/broadcast-channel.module';
import { ExtendedHttpService } from './login/extended-http-service';
import { IpcChannelModule } from './shared/services/ipc-channel/ipc-channel.module';
import { ConfigEffects } from './shared/state-management/effects/config';
import { State as AppState, reducers, reducerFactory } from './shared/state-management/reducers';
import { RouterLoaderModule } from './shared/components/router-loader/router-loader.module';
import { TranslateModule } from './shared/i18n/translate.module';
import { CustomRouteStateSerializer } from './shared/state-management/custom-route-state-serializer';

import { IntrojsModule } from './shared/introjs/introjs.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ExtraauthModule } from './login/extraauth.module';
import { NeoFrameModule } from './neo-frame/neo-frame.module';
import { ArgusFrameModule } from './argus-frame/argus-frame.module';
import { LoginModule } from './login/login.module';

import { environment } from '../environments/environment';
import { DbModule } from './shared/services/db/db.module';
import { DB_TYPE_ACTION_MAPPING } from './shared/services/db/db.tokens';
import { RavenErrorHandler } from './error-handler';
import { WindowRef } from './shared/services/window-ref';
import { AgenciesModule } from './shared/services/agencies/agencies.module';
import { WebserviceModule } from './xena/core/shared/services/webservice/webservice.module';
import { ConfigServiceModule } from './shared/services/config/config-service.module';
import { CrsService } from './xena/core/crs/crs.service';
import { BrowserNotificationService } from './shared/services/browser-notification/browser-notification.service';
import { WebstartModule } from './shared/webstart/webstart.module';
import { ANGULAR_NOTIFIER_CONFIG } from './shared/config/angular-notifier-config';
import { ApiKeysModule } from './shared/services/api-keys/api-keys.module';
import { NewsDialogModule } from './shared/components/news-dialog/news-dialog.module';
import { TourOperatorService } from './xena/core/shared/services/tour-operator/tour-operator.service';
import { NeoFrameService } from './neo-frame/neo-frame.service';
import { WebsocketModule } from './shared/services/websocket/websocket.module';
import { CrsBridgeModule } from './shared/services/crs-bridge/crs-bridge.module';
import { PaxloungeService } from './xena/core/shared/services/paxlounge.service';
import { SearchMaskModule } from './xena/core/shared/mapping/searchmask/searchmask.module';
import { SearchMaskEffects } from './shared/state-management/effects/searchmask';




@NgModule({
	declarations: [ AppComponent ],
	bootstrap: [ AppComponent ],
	imports: [
		HttpModule,
		BrowserModule,
		BrowserAnimationsModule,
		SearchMaskModule,
		ConfigModule.forRoot(ConfigSettings),
		MetaModule.forRoot(),
		StoreModule.forRoot(reducers, {reducerFactory: reducerFactory}),
		EffectsModule.forRoot([AppEffects, RouterEffects, ConfigEffects, SearchMaskEffects]),
		IntrojsModule.forRoot(),
		StoreRouterConnectingModule,
		...LayoutComponentModules,
		DbModule.forRoot(),
		RouterLoaderModule,
		TranslateModule.forRoot(),
		!environment.production ? StoreDevtoolsModule.instrument({maxAge: 5}) : [],
		OAuthModule.forRoot(),
		ExtraauthModule.forRoot(),
		AgenciesModule.forRoot(),
		WebserviceModule,
		NeoFrameModule,
		ArgusFrameModule,
		ConfigServiceModule.forRoot(),
		LoginModule,
		NotifierModule.withConfig(ANGULAR_NOTIFIER_CONFIG),
		BroadcastChannelModule.forRoot(),
		WebsocketModule.forRoot(),
		CrsBridgeModule.forRoot(),
		IpcChannelModule.forRoot(),
		Angulartics2Module.forRoot([Angulartics2GoogleAnalytics], {
			developerMode: !environment.production,
			pageTracking: {clearIds: true},
		}),
		WebstartModule.forRoot(),
		ApiKeysModule,
		NewsDialogModule,
		RouterModule.forRoot([...AppRoutes], {useHash: true}), // TODO hash needed for electron
	],
	providers: [
		{ provide: APP_BASE_HREF, useValue: '/' },
		{ provide: ErrorHandler, useClass: RavenErrorHandler },
		{ provide: RouterStateSerializer, useClass: CustomRouteStateSerializer },
		{ provide: DB_TYPE_ACTION_MAPPING, useValue: {type: 'static', route: 'static/:id', remove: 'YXC'}, multi: true },
		{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
		WindowRef,
		CrsService,
		TourOperatorService,
		BrowserNotificationService,
		Title,
		NeoFrameService,
		PaxloungeService,
		{
			provide: Http,
			deps: [XHRBackend, RequestOptions, Store],
			useFactory: (backend: XHRBackend, defaultOptions: RequestOptions, store: Store<AppState>) => {
				return  new ExtendedHttpService(backend, defaultOptions, store);
			}
		},
	],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts